import { render, staticRenderFns } from "./OnboardOnfido.vue?vue&type=template&id=4247c925&"
import script from "./OnboardOnfido.vue?vue&type=script&lang=js&"
export * from "./OnboardOnfido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports